import { MapTo } from "@adobe/aem-react-editable-components";
import { QrCodeLottery } from "@jti/loyalty";
import { REPLACE_URL_PLACEHOLDER, replaceLoginWithRedirectionUrlPlaceholder, } from "../../app-related/replaceLoginWithRedirectionUrlPlaceholder";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
const lotteryStateItemDateKeys = [
    "title",
    "description",
    "ctaLabel",
    "ctaUrl",
    "secondaryCtaLabel",
    "secondaryCtaUrl",
];
const lotteryStateItemPartialDataKeys = [
    "ctaLabel",
    "title",
    "description",
];
const ctaUnhappyPathDataKeys = [
    "ctaLabel",
    "ctaUrl",
    "secondaryCtaLabel",
    "secondaryCtaUrl",
];
const lostAndParticipatedDataKey = ["title", "description"];
const isPropsMissing = (props, checkProps) => {
    return !props || checkProps.some((key) => !props[key]);
};
export const qrCodeLotteryEditConfig = {
    emptyLabel: "QrCodeLottery",
    isEmpty: (props) => !props.backgroundImage ||
        !props.generalTitle ||
        !props.wheelLoseLabel ||
        !props.wheelPointsLabel ||
        !props.wheelTitle ||
        isPropsMissing(props.won, lotteryStateItemDateKeys) ||
        isPropsMissing(props.alreadyParticipated, lostAndParticipatedDataKey) ||
        isPropsMissing(props.lost, lostAndParticipatedDataKey) ||
        // isPropsMissing(props.logged, lotteryStateItemPartialDataKeys) || // add with DESP-63972
        isPropsMissing(props.notLogged, lotteryStateItemDateKeys) ||
        isPropsMissing(props.spin, lotteryStateItemPartialDataKeys) ||
        isPropsMissing(props.ctasUnhappyPath, ctaUnhappyPathDataKeys),
    getProps: (props) => ({
        backgroundImage: props.backgroundImage,
        mobileBackgroundImage: props.mobileBackgroundImage,
        generalTitle: props.generalTitle,
        won: props.won,
        alreadyParticipated: props.alreadyParticipated,
        lost: props.lost,
        // logged: props.logged, // add with DESP-63972
        notLogged: {
            ...props.notLogged,
            ctaUrl: props.notLogged?.ctaUrl === REPLACE_URL_PLACEHOLDER
                ? replaceLoginWithRedirectionUrlPlaceholder(props.notLogged?.ctaUrl)
                : props.notLogged?.ctaUrl,
            secondaryCtaUrl: props.notLogged?.secondaryCtaUrl === REPLACE_URL_PLACEHOLDER
                ? replaceLoginWithRedirectionUrlPlaceholder(props.notLogged?.secondaryCtaUrl)
                : props.notLogged?.secondaryCtaUrl,
        },
        spin: props.spin,
        ctasUnhappyPath: props.ctasUnhappyPath,
        wheelLoseLabel: props.wheelLoseLabel,
        wheelPointsLabel: props.wheelPointsLabel,
        wheelTitle: props.wheelTitle,
    }),
};
export default MapTo("loyalty/components/qr-code-lottery")(withAemAuthoring(QrCodeLottery, qrCodeLotteryEditConfig));
